<script lang="ts">
  import { onMount } from 'svelte';

  type ValidDetail = { name: string; value: string };
  type InvalidDetail = { name: string; value: string; error: string };
  type ChangeDetail = { name: string; value: string };

  // --- Props ---
  export let value: string = '';
  export let name: string;
  export let label: string = '';
  export let placeholder: string = '';
  export let type: 'text' | 'email' | 'password' = 'text';
  export let validator: (val: string) => string | null = () => null;

  export let onValid: (detail: ValidDetail) => void = () => {};
  export let onInvalid: (detail: InvalidDetail) => void = () => {};
  export let onChange: (detail: ChangeDetail) => void = () => {};

  let error: string | null = null;

  const clear = () => {
    value = '';
    validate();
  };

  const validate = () => {
    error = validator(value);
    if (error) {
      onInvalid({ name, value, error });
    } else {
      onValid({ name, value });
    }
  };

  const handleInput = () => {
    if (error) {
      error = null;
    }
    onChange({ name, value });
  };

  onMount(async () => {
    if (value === '') return;
    validate();
  });
</script>

<div class="cs-input-wrapper">
  {#if label}
    <label for={name}>{label}</label>
  {/if}
  <input
    {type}
    {name}
    id={name}
    class="cs-search-input"
    {placeholder}
    bind:value
    on:input={handleInput}
    on:keydown={validate}
    on:change={validate}
    on:blur={validate}
    aria-invalid={!!error}
  />

  {#if value}
    <button on:click={clear} class="cs-input-clear">x</button>
  {/if}
  {#if error}
    <p class="cs-error-msg">{error}</p>
  {/if}
</div>

<style lang="scss">
  @use './../../../scss/components/themes/input-theme';
</style>
